<erp-confirmation-dialog></erp-confirmation-dialog>

<erp-information-dialog></erp-information-dialog>

<his-search-result #SearchResultComponent searchConfigFile="{{SEARCH_CONFIG_PROJECT}}" [showTitle]="true"
    [showNewSearchButton]="true" [showBackButton]="true" [showChangeSearchButton]="true"
    defaultActionRoute="/businesstripapplication/edit/:id" idColumn="BusinesstripApplication.id"
    defaultColumn="BusinesstripApplication.id">
    <ng-template #rowAction let-index="index" let-row="row">
        <!-- edit button -->
        <ng-container
            *ngIf="auth.hasAny('RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_EDIT_BUSINESSTRIPAPPLICATION')">
            <a routerLink="/businesstripapplication/edit/{{row.get('BusinesstripApplication.id')}}"
                [queryParams]="{showBackButton: true, showSearchButton: true}" hisImage="pencil"
                [title]="'common.edit' | hisUi"></a>
        </ng-container>

        <!-- delete button -->
        <ng-container
            *ngIf="auth.hasAny('RIGHT_RM_ERP_TRAVELMANAGEMENT_BUSINESSTRIPAPPLICATION_DELETE_BUSINESSTRIPAPPLICATION')">
            <button (click)="deleteRow(index,row)" hisImage="delete" class="icon"
                [title]="'common.delete' | hisUi"></button>
        </ng-container>
    </ng-template>
</his-search-result>